<template>
  <div id="DepartmentManage" class="well" style="padding: 0 1em">
    <b-button variant="success" v-on:click="dataMode = 0">金額統計</b-button>
    <b-button variant="success" v-on:click="dataMode = 1">人數統計</b-button>
    <b-tabs content-class="mt-3" justified>
      <b-tab :active="dataMode == 0" :disabled="dataMode != 0">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請年度：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>
                <th style="min-width: 6em"></th>
                <th style="min-width: 5em"></th>

                <th style="min-width: 30em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query(0)"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/SportsExcellent/GetSportsODS2/'.concat(
                        queryInfo.STime
                      )
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.Excel_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            v-if="docRecordList != null"
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 10em">競賽種類名稱\系所</th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[0] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[1] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[2] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[3] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[4] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[5] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[6] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[7] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[8] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[9] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[10] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[11] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[12] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[13] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[14] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[15] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[16] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[17] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[18] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[19] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[20] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[21] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[22] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[23] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[24] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[25] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[26] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[27] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[28] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[29] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[30] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[31] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[32] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[33] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[34] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[35] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[36] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[37] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[38] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[39] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[40] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[41] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[42] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[43] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[44] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[45] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[46] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[47] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[48] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[49] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[50] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[51] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[52] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[53] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[54] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[55] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[56] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[57] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[58] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[59] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[60] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[61] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[62] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[63] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[64] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[65] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[66] }}
                </th>
              </tr>
            </thead>
            <tbody v-if="docRecordList != null" class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in TypeNameList"
                :key="item.sn"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: left">
                  {{ item.typeName }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[0] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[1] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[2] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[3] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[4] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[5] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[6] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[7] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[8] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[9] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[10] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[11] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[12] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[13] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[14] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[15] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[16] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[17] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[18] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[19] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[20] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[21] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[22] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[23] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[24] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[25] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[26] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[27] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[28] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[29] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[30] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[31] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[32] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[33] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[34] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[35] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[36] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[37] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[38] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[39] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[40] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[41] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[42] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[43] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[44] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[45] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[46] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[47] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[48] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[49] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[50] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[51] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[52] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[53] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[54] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[55] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[56] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[57] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[58] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[59] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[60] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[61] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[62] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[63] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[64] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[65] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[66] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab :active="dataMode == 1" :disabled="dataMode != 1">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請年度：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>
                <th style="min-width: 6em"></th>
                <th style="min-width: 5em"></th>

                <th style="min-width: 30em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query(1)"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/SportsExcellent/GetSportsODS21/'.concat(
                        queryInfo.STime
                      )
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.Excel_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            v-if="docRecordList != null"
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 10em">競賽種類名稱\系所</th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[0] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[1] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[2] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[3] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[4] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[5] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[6] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[7] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[8] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[9] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[10] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[11] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[12] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[13] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[14] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[15] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[16] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[17] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[18] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[19] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[20] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[21] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[22] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[23] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[24] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[25] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[26] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[27] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[28] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[29] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[30] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[31] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[32] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[33] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[34] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[35] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[36] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[37] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[38] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[39] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[40] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[41] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[42] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[43] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[44] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[45] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[46] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[47] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[48] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[49] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[50] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[51] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[52] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[53] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[54] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[55] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[56] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[57] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[58] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[59] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[60] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[61] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[62] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[63] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[64] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[65] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[66] }}
                </th>
              </tr>
            </thead>
            <tbody v-if="docRecordList != null" class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in TypeNameList"
                :key="item.sn"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: left">
                  {{ item.typeName }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[0] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[1] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[2] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[3] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[4] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[5] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[6] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[7] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[8] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[9] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[10] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[11] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[12] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[13] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[14] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[15] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[16] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[17] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[18] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[19] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[20] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[21] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[22] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[23] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[24] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[25] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[26] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[27] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[28] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[29] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[30] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[31] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[32] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[33] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[34] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[35] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[36] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[37] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[38] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[39] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[40] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[41] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[42] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[43] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[44] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[45] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[46] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[47] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[48] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[49] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[50] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[51] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[52] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[53] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[54] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[55] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[56] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[57] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[58] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[59] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[60] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[61] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[62] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[63] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[64] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[65] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].number[66] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from "../tool";
export default {
  name: "DepartmentManage",
  data() {
    return {
      TypeNameList: [],
      total: 0,
      dataMode: 0,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        STime: null,
        ETime: null,
        dataMode: 0,
      },
      docRecordList: null,
    };
  },

  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    setting() {
      return this.$store.getters.getSetting;
    },

    // filteredDocs: function () {
    //   let data = [];
    //   if (this.docRecordList != null) {
    //     data = this.docRecordList.slice(
    //       (this.currentPage - 1) * this.pageSize,
    //       this.currentPage * this.pageSize
    //     );
    //   }
    //   return data;
    // },
    headerColor() {
      return "#f7e8aa";
    },
  },
  filters: {},
  methods: {
    checkSaveData() {
      let msg = "";
      if (this.queryInfo.STime == null) msg = "請輸入申請年度";

      return msg;
    },
    query(mode) {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.TypeNameList=[];
        vm.docRecordList = null;
        vm.total = 0;
        vm.queryInfo.dataMode = vm.dataMode;

        if (mode == 0) {
          this.$http
            .put("./WebApi/SportsExcellent/GetDepTypeNameList", vm.queryInfo)
            .then((response) => {
              if (response.data != null) {
                vm.docRecordList = response.data;

                vm.total = vm.docRecordList.length;

                for (let i = 0; i < vm.docRecordList.length; i++) {
                   // 創建一個包含 typename 屬性的物件，並將其添加到 TypeNameList
        vm.TypeNameList[i] = { typeName: vm.docRecordList[i].typeName,sn:i+1 };

                }

                //  vm.getAllTypeName(0);
              }
            })
            .catch(function (error) {
              tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
            });
        } else {
          this.$http
            .put("./WebApi/SportsExcellent/GetDepTypeNameList2", vm.queryInfo)
            .then((response) => {
              if (response.data != null) {
                vm.docRecordList = response.data;

                vm.total = vm.docRecordList.length;

                for (let i = 0; i < vm.docRecordList.length; i++) {
                   // 創建一個包含 typename 屬性的物件，並將其添加到 TypeNameList
        vm.TypeNameList[i] = { typeName: vm.docRecordList[i].typeName,sn:i+1 };

                }

                //vm.getAllTypeName(0);
              }
            })
            .catch(function (error) {
              tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
            });
        }
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
    // getAllTypeName(mode) {
    //   let vm = this;
    //   this.$http
    //     .get("./WebApi/SportsExcellent/GetAllTypeName/".concat(mode))
    //     .then((response) => {
    //       if (!tools.isNull(response)) {
    //         vm.TypeNameList = response.data;
    //       }
    //     })
    //     .catch(function (error) {
    //       alert("網路連線失敗" + error);
    //       // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
    //     });
    // },
  },
  created() {
    console.log("======created DepartmentManageView =====");
    //  this.getAllTypeName();
  },
  mounted() {
    console.log("======mounted DepartmentManageView =====");

    //   this.getAllmini_name_data2();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
